/* eslint-disable prefer-destructuring */

import { defineNuxtPlugin, showError, useRouter } from '#imports'
import type { RouteLocationNormalized } from 'vue-router'

export type RouteExistsGuard = (
  to: RouteLocationNormalized,
) => boolean | { message?: string; status?: number }

export default defineNuxtPlugin(() => {
  const router = useRouter()

  const doesRouteExist = (
    to: RouteLocationNormalized,
  ): { ok: true } | { ok: false; message?: string; status?: number } => {
    const routeExists = to.meta.routeExists

    if (routeExists === undefined) return { ok: true }

    if (routeExists === true) return { ok: true }

    const routeExistsResult =
      typeof routeExists === 'function' ? routeExists(to) : routeExists

    if (typeof routeExistsResult === 'boolean') {
      return { ok: routeExistsResult }
    }

    // if routeExistsResult is an object, it means the route does not exist
    return {
      ...routeExistsResult,
      ok: false,
    }
  }

  router.afterEach((to) => {
    const result = doesRouteExist(to)

    if (!result.ok) {
      const { message, status } = result
      showError({
        status: status || 404,
        fatal: true,
        message: message || 'Route does not exist',
      })
    }
  })
})
